import { ACTIF } from '@/configuration/compta/lotConf';

export default function genererCritereRecherche() {
  return {
    libelle: '',
    etat: ACTIF,
  };
}
